import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MontaTurmasComponent } from './pages/monta-turmas/monta-turmas.component';
import { DataTablesModule } from 'angular-datatables';
import { CollapseModule } from 'ngx-bootstrap/collapse';

@NgModule({
  imports: [
    CommonModule,
    DataTablesModule,
    FormsModule,
    CollapseModule.forRoot(),
  ],
  exports: [MontaTurmasComponent],
  declarations: [MontaTurmasComponent],
  providers: [],
})
export class InscricoesModule {}
